module.exports = __webpack_public_path__ + "static/img/giftcard.543e4b57.jpg";